import { Database } from "services/databases/useDatabasesNames";

export const DATABASE_BATCH_SIZE = 20;
export const DATABASE_LIMIT = 60;

/**
 * Builds SQL query to search tables, columns, and indexes across databases.
 */
export const buildSearchSql = (databases: Database[]): string => {
  return databases
    .map(db => {
      const catalog = `"${db.catalogName}"`;
      return `
SELECT
  t.table_catalog,
  t.table_schema,
  t.table_name,
  t.table_name as object_name,
  'table' as object_type,
  null as data_type,
  t.table_type,
  null as index_type,
  null as index_name,
  null as index_definition
FROM ${catalog}.information_schema.tables t
WHERE
  t.table_catalog ILIKE :searchTerm
  OR t.table_schema ILIKE :searchTerm
  OR t.table_name ILIKE :searchTerm
UNION ALL
SELECT
  c.table_catalog,
  c.table_schema,
  c.table_name,
  c.column_name as object_name,
  'column' as object_type,
  c.data_type,
  null as table_type,
  null as index_type,
  null as index_name,
  null as index_definition
FROM ${catalog}.information_schema.columns c
WHERE
  c.table_catalog ILIKE :searchTerm
  OR c.table_schema ILIKE :searchTerm
  OR c.table_name ILIKE :searchTerm
  OR c.column_name ILIKE :searchTerm
UNION ALL
SELECT
  i.table_catalog,
  i.table_schema,
  i.table_name,
  i.index_name as object_name,
  'index' as object_type,
  null as data_type,
  null as table_type,
  i.index_type,
  i.index_name,
  i.index_definition
FROM ${catalog}.information_schema.indexes i
WHERE
  i.table_catalog ILIKE :searchTerm
  OR i.table_schema ILIKE :searchTerm
  OR i.table_name ILIKE :searchTerm
  OR i.index_name ILIKE :searchTerm`;
    })
    .join(" UNION ALL\n");
};

/**
 * Splits databases into chunks for batched queries.
 */
export const chunkDatabases = (databases: Database[]): Database[][] => {
  const chunks: Database[][] = [];
  for (let i = 0; i < databases.length; i += DATABASE_BATCH_SIZE) {
    chunks.push(databases.slice(i, i + DATABASE_BATCH_SIZE));
  }
  return chunks;
};
